import React from "react";
export default function GetInTouch(){
    return(
        <div>
            <div className={"brijesh_wrapper p-0"}>
                <div className={"container section_title_main project_wrapper pt-0 mt-4"} id={"get-in-touch"}>
                    <h3 className={"section_title mt-2 pt-0 pt-lg-5 mt-lg-5 mb-lg-3 my-md-2 mb-0 text-center"}>Get In Touch</h3>
                    <div className={"row px-lg-5 mx-lg-5 mt-lg-0 mt-2 mx-2"}>
                        <div className={"col-xl-12 d-flex justify-content-center align-item-center"}>
                            <div className={"col-xl-9 col-12"}>
                                <p className={"text-center get_intouch_disciption"}>
                                Although I’m not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you!
                                </p>
                                {/*<button type={"button"} className={"contact_me"}>*/}
                                    <a className={"contact_me my-3"} href="mailto:brijeshlathiya8586@gmail.com">Contact me</a>
                                {/*</button>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}